/**
 * Controla una aplicación de gestión de correo
 */
class validateInput {

  /**
   * @param {errorClass}
   * @param {successClass}
   */
  constructor(errorClass, successClass) {
    this._errorClass = errorClass;
    this._successClass = successClass;
  }

  /**
   * Valida el input
   */
  validateRequired(input) {
    var value = input.val();
    if (value) {
        input.removeClass(this._errorClass).addClass(this._successClass);
        return true;
    } else {
        input.removeClass(this._successClass).addClass(this._errorClass);
        return false;
    }
  }

  /**
   * Valida el input
   */
  validateIsPhone(input) {
    var filter = /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/;
    var value = input.val();

    var is_phone = filter.test(input.val());

    if (is_phone) {
        input.removeClass(this._errorClass).addClass(this._successClass);
        return true;
    } else {
        input.removeClass(this._successClass).addClass(this._errorClass);
        return false;
    }
  }

  /**
   * Valida el input
   */
  validateIsEmail(input) {
    var re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    var value = input.val();

    var is_email = re.test(input.val());

    if (is_email) {
      input.removeClass(this._errorClass).addClass(this._successClass);
      return true;
    } else {
      input.removeClass(this._successClass).addClass(this._errorClass);
      return false;
    }
  }

  /**
   * Valida el input
   */
  validateIsSelected(input) {
    var value = input.val();
    if (value != '') {
        input.removeClass(this._errorClass).addClass(this._successClass);
        return true;
    } else {
        input.removeClass(this._successClass).addClass(this._errorClass);
        return false;
    }
  }

  /**
   * Valida el input
   */
  validateIsNumber(input) {
    var value = input.val();

    if ($.isNumeric(value) && value > 0) {
        input.removeClass(this._errorClass).addClass(this._successClass);
        return true;
    } else {
        input.removeClass(this._successClass).addClass(this._errorClass);
        return false;
    }
  }

  /**
   * Valida el input
   */
  validateIsChecked(input, label) {
    if (!input.is(':checked')) {
        $(label).removeClass(this._successClass).addClass(this._errorClass);
        return false;
    } else {
        $(label).removeClass(this._errorClass).addClass(this._successClass);

        return true;
    }
  }

    /**
     * Valida el input
     */
    validateIsDNI(input) {
        var dni = input.val();

        const dniRegex = /^(\d{8})([A-Z])$/;
        const nifRegex = /^[XYZ]\d{7}[A-Z]$/;
        const letras = 'TRWAGMYFPDXBNJZSQVHLCKE';

        let numero, letraCalculada, letra;

        if (dniRegex.test(dni)) {
            numero = parseInt(dni.match(dniRegex)[1], 10);
            letra = dni.match(dniRegex)[2];
            letraCalculada = letras[numero % 23];
            if(letra === letraCalculada){
                input.removeClass(this._errorClass).addClass(this._successClass);
                return true;
            }else{
                input.removeClass(this._successClass).addClass(this._errorClass);
                return false;
            }
        } else if (nifRegex.test(dni)) {
            numero = dni.replace('X', '0').replace('Y', '1').replace('Z', '2');
            numero = parseInt(numero.substr(0, 8), 10);
            letra = dni.charAt(8);
            letraCalculada = letras[numero % 23];
            if(letra === letraCalculada){
                input.removeClass(this._errorClass).addClass(this._successClass);
                return true;
            }else{
                input.removeClass(this._successClass).addClass(this._errorClass);
                return false;
            }
        }

        input.removeClass(this._successClass).addClass(this._errorClass);
        return false;
    }

}

export default validateInput;
